import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import SchedulePage from './pages/SchedulePage';
import ApplicationFormPage from './pages/ApplicationFormPage';
import InvitePage from './pages/InvitePage';
import StaffInvitePage from './pages/StaffInvitePage';
import DashboardLayout from './pages/DashboardLayout';
import GuestPortalPage from './pages/GuestPortalPage';
import AccountPage from './pages/AccountPage';
import NominationPage from './pages/NominationPage';

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* LP */}
          <Route path="/" element={<LandingPage />} />

          {/* キャスト向け出欠入力（認証不要・公開） */}
          <Route path="/schedule/:eventId/:token" element={<SchedulePage />} />

          {/* 応募フォーム（認証不要・公開） */}
          <Route path="/apply/:token" element={<ApplicationFormPage />} />

          {/* 指名設定（認証不要・公開） */}
          <Route path="/nominate/:token" element={<NominationPage />} />

          {/* 認証不要 */}
          <Route path="/login" element={<LoginPage />} />
          {/* superadminがownerを招待するFirebaseメールフロー */}
          <Route path="/invite" element={<InvitePage />} />
          {/* ownerがstaffを招待するトークンフロー */}
          <Route path="/invite/:token" element={<StaffInvitePage />} />

          {/* 全ロール共通のダッシュボード（内部で権限による表示制御） */}
          <Route path="/dashboard" element={
            <ProtectedRoute allowedRoles={['superadmin', 'owner', 'staff']}>
              <DashboardLayout />
            </ProtectedRoute>
          } />

          {/* ゲストポータル（全ロール・要ログイン） */}
          <Route path="/portal" element={
            <ProtectedRoute allowedRoles={['guest', 'owner', 'staff', 'superadmin']}>
              <GuestPortalPage />
            </ProtectedRoute>
          } />

          {/* アカウント設定（全ロール・要ログイン） */}
          <Route path="/account" element={
            <ProtectedRoute allowedRoles={['guest', 'owner', 'staff', 'superadmin']}>
              <AccountPage />
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;